
namespace RioERP.Orders {
    export class OrdersColumns {
        static columnsKey = 'Orders.Orders';
    }
}